/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TaxRatesV2Dto as DigiworkMaitreDPosDtoTaxRatesV2TaxRatesV2Dto } from '../../models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/tax-rates-v-2-dto';

export interface GetTaxRates$Params {
  companyId?: string;
  isRemoved?: boolean;
  searchTerm?: string;
}

export function getTaxRates(http: HttpClient, rootUrl: string, params?: GetTaxRates$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRatesV2Dto>> {
  const rb = new RequestBuilder(rootUrl, getTaxRates.PATH, 'get');
  if (params) {
    rb.query('companyId', params.companyId, {});
    rb.query('isRemoved', params.isRemoved, {});
    rb.query('searchTerm', params.searchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRatesV2Dto>;
    })
  );
}

getTaxRates.PATH = '/api/tax-rates';
